import {EntityData, field, identifier, LocalisableEntityData} from "@fedeltapointofsale/data-client";

export class TaxData extends LocalisableEntityData<TaxData> {
    static readonly ADDITIVE_METHOD: string = "additive";
    static readonly SUBTRACTIVE_METHOD: string = "subtractive";

    @identifier id: number;
    @field name: string;
    @field method: string = TaxData.ADDITIVE_METHOD;
    @field percent: number;
    @field defaultTax: boolean = false;
    @field priority: number = 0;
    @field excludedFromBasePrice: boolean = false;
}

export class TaxReferenceData extends LocalisableEntityData<TaxData> {
    @identifier id: number;
    @field name: string;

    public static clone(other: TaxReferenceData): TaxReferenceData {
        const tax = <TaxReferenceData> EntityData.create(TaxReferenceData);
        tax.id = other.id;
        tax.name = other.name;
        return tax;
    }
}
